module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-head-cell-active-left.f644739a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-head-cell-active-left.png
// module id = 3820
// module chunks = 11